import {
    EFFICIENCY_CLASS,
    EFFICIENCY_CLASS_LEXUS,
    EFFICIENCY_CLASS_TMEF,
} from "../../../../common-deprecated/constants";
import type { SpecDataType } from "../../../../common-deprecated/types/SpecTypes";
import type { EcoLabelConfig } from "../../../shared-logic/types/Motorization";

export const getTechSpecsLabelConfig = (
    flattendTechSpecs: SpecDataType[],
    isAlternateFlow: boolean = false,
): EcoLabelConfig => {
    if (isAlternateFlow) return { show: false };
    const efficiencySpec = flattendTechSpecs.find(
        ({ internalCode }) =>
            internalCode === EFFICIENCY_CLASS ||
            internalCode === EFFICIENCY_CLASS_TMEF ||
            internalCode === EFFICIENCY_CLASS_LEXUS,
    );
    const co2combinedwltp = flattendTechSpecs.find(
        ({ internalCode }) => internalCode === "CO2COMBINEDWLTP" || internalCode === "CO2COMBINEDCSWLTP",
    );
    if (co2combinedwltp && efficiencySpec) {
        return {
            show: true,
            label: {
                letter: efficiencySpec.value,
                label: `${co2combinedwltp.value} ${co2combinedwltp.unit}`,
            },
        };
    }

    return {
        show: false,
    };
};
